<template>
  <b-container>
    <b-row style="border: solid; margin: 5px; padding: 5px;">
      <b-col style="min-width: 375px;">
        <label for="input-name">Full Name *: </label>
        <b-form-input
          id="input-name"
          v-model="formData.name"
          type="text"
          required
          :state="validName"
          aria-aria-describedby="input-name-feedback"
          placeholder="Full Name"/>
        <b-form-invalid-feedback id="input-name-feedback">Minimum 3 Letters</b-form-invalid-feedback>
        <label for="input-email">eMail *: </label>
        <b-form-input
          id="input-email"
          v-model="formData.email"
          type="email"
          required
          :state="validEmail"
          placeholder="eMail"/>
      </b-col>
      <b-col style="min-width: 375px;">
        <label for="signatureCanvasId">Signature *: </label>
        <div>
          <canvas id="signatureCanvasId" ref="signatureCanvasRef" style="border: solid;"></canvas>
        </div>
      </b-col>
    </b-row>
    <b-row style="border: solid; margin: 5px; padding: 5px;">
      <b-col><b-button @click="handleSaveSignature" variant="primary">Save</b-button></b-col>
      <b-col><b-button :disabled="!validFormData" @click="handleUpload" variant="warning">Upload</b-button></b-col>
      <b-col><b-button @click="handleClear" variant="danger">Clear</b-button></b-col>
    </b-row>
    <b-row style="margin: 5px;">
      <iframe id="pdfDocIFrameId" ref="pdfDocIFrameRef" style="width: 100%; height: 100%; min-height: 500px;"></iframe>
    </b-row>
    <b-modal ref="docUploadedModalRef" id="docUploadedId" title="Document uploaded!"
      @ok="handleClear" ok-only>
      <p v-if="docUploadedMsg">
        {{ docUploadedMsg }}
      </p>
      <p v-else style="color: red;">
        There was an error during the upload! Please try again later!
      </p>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import SignaturePad from 'signature_pad'
import { PDFDocument, rgb } from 'pdf-lib'

import { SIGN_DOC_SIGN_PAD_DIMS } from './constants'

const __defaultDocUploadedMsg = () => 'Your signed Document was successfully uploaded!' +
  ' It is now available under: '

export default {
  name: 'pdf-viewer',
  version: '0.0.1',
  props: {
    docsInstKey: {
      type: String,
      required: true
    }, // docsInstKey
    fileUrl: {
      type: String,
      default: null
    }, // fileUrl
    signAreaList: {
      type: Array,
      default: () => []
    } // signAreaList
  }, // props
  data () {
    return {
      pdfDoc: null,
      signaturePad: null,
      signatureSaved: false,
      formData: {
        name: null,
        email: null
      },
      docUploadedMsg: null
    }
  }, // data
  computed: {
    validName: function () {
      return (this.formData.name && this.formData.name.length > 3) ? true : false
    }, // validName
    validEmail: function () {
      // TODO: extend the validation with @ char
      return (this.formData.email && this.formData.email.length > 3) ? true : false
    }, // validEmail
    validFormData: function () {
      return (this.validName && this.validEmail && this.signatureSaved)
    } // validFormData
  }, // computed
  watch: {
  }, // watch
  async mounted () {
    console.log('TRACE-REMOVE: PdfViewer.mounted!')
    try {
      // const signatureCanvas = document.getElementById("signatureCanvasId");
      const signatureCanvas = this.$refs.signatureCanvasRef
      console.log('TRACE-REMOVE: PdfViewer.mounted: signatureCanvas is: ', signatureCanvas)
      console.log('TRACE-REMOVE: PdfViewer.mounted: SIGN_DOC_SIGN_PAD_DIMS is: ', SIGN_DOC_SIGN_PAD_DIMS)
      signatureCanvas.width = SIGN_DOC_SIGN_PAD_DIMS.x
      signatureCanvas.height = SIGN_DOC_SIGN_PAD_DIMS.y
      this.signaturePad = new SignaturePad(signatureCanvas);

      if (await this.loadPdfDoc()) {
        await this.renderPdfDoc()
      }
    } catch (e) {
      console.error('ERROR: Error mounting the PdfViewer: ', e)
    }
  }, // mounted
  methods: {
    async loadPdfDoc () {
      if (!this.fileUrl) {
        console.log('WARN: no fileUrl! pdfLib will not be initialized!')
        return false
      }
      let _ret = true
      try {
        const existingPdfBytes =
          await axios.get(this.fileUrl, { responseType: 'arraybuffer' }).
          then(res => res.data)
        this.pdfDoc = await PDFDocument.load(existingPdfBytes)
      } catch (e) {
        console.error('ERROR: Error loading the pdf document: ', e)
        _ret = false
      }
      return _ret
    }, // loadPdfDoc
    async renderPdfDoc () {
      if (!this.pdfDoc) {
        console.log('WARN: no pdfDoc!')
        return
      }
      try {
        const _hasSignature = (this.signaturePad && this.signatureSaved)
        const pngSignatureImg =
          _hasSignature ? await this.pdfDoc.embedPng(this.signaturePad.toDataURL()) : null
        const page = this.pdfDoc.getPage(0)

        for (var sa of this.signAreaList) {
          if (_hasSignature) {
            const pngDims = pngSignatureImg.scale(1)
            page.drawImage(pngSignatureImg, {
              x: Number(sa.x),
              y: page.getHeight() - (Number(sa.y) + pngDims.height),
              width: pngDims.width,
              height: pngDims.height,
            })
          } else {
            page.drawRectangle({
              x: Number(sa.x),
              y: page.getHeight() - (Number(sa.y) + 80),
              width: SIGN_DOC_SIGN_PAD_DIMS.x,
              height: SIGN_DOC_SIGN_PAD_DIMS.y,
              borderWidth: 1,
              borderColor: rgb(1, 0, 0),
              color: rgb(0.8, 0.8, 0.8)
            })
          }
        }
        // document.getElementById('pdfDocIFrameId').src =
        //   await this.pdfDoc.saveAsBase64({ dataUri: true })
        this.$refs.pdfDocIFrameRef.src =
          await this.pdfDoc.saveAsBase64({ dataUri: true })
      } catch (e) {
        console.error('ERROR: Error rendering the pdf: ', e)
      }
    }, // renderPdfDoc
    async handleSaveSignature () {
      this.signatureSaved = true
      if (await this.loadPdfDoc()) {
        await this.renderPdfDoc()
      }
    }, // handleSaveSignature
    async handleUpload () {
      console.log('TRACE-REMOVE: PdfViewer.handleUpload!')
      try {
        this.docUploadedMsg = null

        let _formData = new FormData()
        _formData.append('name', this.formData.name)
        _formData.append('email', this.formData.email)
        _formData.append('pdfDocsBytesBase64', await this.pdfDoc.saveAsBase64())
        const _ret = await axios.post(
          config.glapiBaseUri + '/docs/' + this.docsInstKey + '/signDocUploads',
          _formData
        )
        if (_ret.data.status == 'success') {
          this.docUploadedMsg = __defaultDocUploadedMsg() + config.glapiBaseUri +
            '/docs/' + this.docsInstKey + '/signDocUploads/' +
            _ret.data.payload.pdfFileKey + '.pdf'

        }
      } catch (e) {
        console.error('ERROR: Failed to upload signed doc! Exception is: ', e)
      } finally {
        this.$refs.docUploadedModalRef.show()
      }
    }, // handleUpload
    async handleClear () {
      this.signatureSaved = false
      if (this.signaturePad) {
        this.signaturePad.clear()
      }
      this.formData.name = null
      this.formData.email = null
      this.docUploadedMsg = null
      if (await this.loadPdfDoc()) {
        await this.renderPdfDoc()
      }
    } // handleClear
  }
}
</script>

<style>
#pageContainer {
  margin: auto;
  width: 80%;
}

div.page {
  display: inline-block;
}
</style>
